export const enum MutationNames {
  updateUnits = 'UNITS_UPDATE_UNITS',
}

export const enum ActionNames {
  getUnits = 'SITE_GET_UNITS',
  patchUnit = 'UNIT_PATCH_UNIT',
}

export const enum GetterNames {
  units = 'SITE_UNITS',
}
